var $18ac2ceede598103$exports = {};
$18ac2ceede598103$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Seleccionar un art\xedculo`,
    "tableResizer": `Cambiador de tama\xf1o`,
    "colorSwatchPicker": `Color swatches`
};


export {$18ac2ceede598103$exports as default};
//# sourceMappingURL=es-ES.mjs.map
